<app-nav></app-nav>

<div class="notification-container">

  <!-- LEFT PANEL -->
  <div class="notification-list">

    <div class="list-top">

    <div class="list-header">
      <h3>Notifications</h3>
    </div>

    <div class="filter-tabs">
      <button [class.active]="filterType === 'all'" (click)="setFilter('all')">
        All
      </button>

      <button [class.active]="filterType === 'unread'" (click)="setFilter('unread')">
        Unread
      </button>
    </div>

  </div>

    <!-- NOTIFICATION ITEMS -->

    <div
      class="notification-item"
      *ngFor="let n of filteredNotifications; trackBy: trackById"
      [class.unread]="!n.isRead"
      (click)="selectNotification(n)">

      <div class="content">
        <h4>{{ n.title }}</h4>
        <small>{{ n.createdAt | date:'MMMM d, y, h:mm a' }}</small>
      </div>

      <span *ngIf="!n.isRead" class="dot"></span>

    </div>

  </div>


  <!-- RIGHT PANEL -->
  <div class="notification-detail" [class.active]="selectedNotification">

  <ng-container *ngIf="selectedNotification; else emptyState">

    <!-- BACK BUTTON -->
    <button class="back-btn" (click)="goBack()">
      ← Back
    </button>

    <!-- MESSAGE HEADER -->
    <div class="message-header">

      <h2 class="detail-title">
        {{ selectedNotification.title }}
      </h2>

      <p class="date">
        {{ selectedNotification.createdAt | date:'MMMM d, y, h:mm a' }}
      </p>

    </div>
    <!-- NOTIFICATION IMAGE -->
    <div class="notification-image-box" *ngIf="selectedNotification.data?.imageUrl">
      <img
        class="notification-image"
        [src]="selectedNotification.data?.imageUrl"
        alt="">
    </div>

    <!-- MESSAGE BODY -->
    <div class="message-box" [innerHTML]="selectedNotification.message"></div>

  </ng-container>

  <ng-template #emptyState>
    <div class="empty-state">
      <div class="bell-icon">🔔</div>
      <h3>Select a notification to view details</h3>
      <p>Choose from the list on the left</p>
    </div>
  </ng-template>

</div>

</div>